import * as THREE from 'three';

// 关卡玩法的两张代码绘制贴图（与纸艺画面同一套干净平涂风格：不加颗粒 / 噪点 / 纤维）。

const tex = (c: HTMLCanvasElement) => {
  const t = new THREE.CanvasTexture(c);
  t.colorSpace = THREE.SRGBColorSpace;
  t.anisotropy = 4;
  return t;
};

/**
 * 旋转块角标：奶白圆片 + 深棕描边 + 一个顺时针的弯箭头（"点一下转 90°"）。
 * 画在 128px 画布上，棋盘里只显示 12–22px，所以线条加粗、只用两种颜色。
 */
export function createRotateBadgeTexture(size = 128): THREE.CanvasTexture {
  const c = document.createElement('canvas');
  c.width = c.height = size;
  const g = c.getContext('2d')!;
  const m = size / 2;
  // 投影：只往下偏一点，像贴在纸上的小圆贴纸
  g.fillStyle = 'rgba(60, 38, 14, 0.28)';
  g.beginPath();
  g.arc(m, m + size * 0.045, size * 0.44, 0, Math.PI * 2);
  g.fill();
  g.fillStyle = '#fff8ea';
  g.strokeStyle = '#7a4b22';
  g.lineWidth = size * 0.06;
  g.beginPath();
  g.arc(m, m, size * 0.4, 0, Math.PI * 2);
  g.fill();
  g.stroke();
  // 顺时针弯箭头：从左上开始，绕过顶部、右侧，停在下方，箭头朝顺时针方向
  const r = size * 0.22;
  const a0 = Math.PI * 0.95;
  const a1 = Math.PI * 2.45;
  g.strokeStyle = '#c2571f';
  g.lineWidth = size * 0.095;
  g.lineCap = 'round';
  g.beginPath();
  g.arc(m, m, r, a0, a1);
  g.stroke();
  // 箭头尖：沿切线方向（顺时针 = 角度增大方向）
  const ex = m + r * Math.cos(a1);
  const ey = m + r * Math.sin(a1);
  const tx = -Math.sin(a1);
  const ty = Math.cos(a1);
  const nx = Math.cos(a1);
  const ny = Math.sin(a1);
  const L = size * 0.17;
  const W = size * 0.13;
  g.fillStyle = '#c2571f';
  g.beginPath();
  g.moveTo(ex + tx * L * 0.75, ey + ty * L * 0.75);
  g.lineTo(ex - tx * L * 0.35 + nx * W, ey - ty * L * 0.35 + ny * W);
  g.lineTo(ex - tx * L * 0.35 - nx * W, ey - ty * L * 0.35 - ny * W);
  g.closePath();
  g.fill();
  return tex(c);
}

/**
 * 背面块的纸背：牛皮纸平涂 + 一圈浅色压线 + 正中一个小菱形印记。完全平涂，没有纹理噪点。
 * 整块贴（UV 0..1），任何格数下都只是"一张素纸片"，一眼能和画面块区分开。
 */
export function createTileBackTexture(size = 128): THREE.CanvasTexture {
  const c = document.createElement('canvas');
  c.width = c.height = size;
  const g = c.getContext('2d')!;
  g.fillStyle = '#d6c19a';
  g.fillRect(0, 0, size, size);
  // 边缘一圈略深：像纸片的厚度
  g.strokeStyle = '#bfa67b';
  g.lineWidth = size * 0.05;
  g.strokeRect(size * 0.025, size * 0.025, size * 0.95, size * 0.95);
  // 压线
  g.strokeStyle = 'rgba(255, 249, 232, 0.75)';
  g.lineWidth = size * 0.028;
  const p = size * 0.15;
  g.strokeRect(p, p, size - 2 * p, size - 2 * p);
  // 小菱形印记
  const m = size / 2;
  const d = size * 0.13;
  g.fillStyle = '#b89a68';
  g.beginPath();
  g.moveTo(m, m - d);
  g.lineTo(m + d * 0.72, m);
  g.lineTo(m, m + d);
  g.lineTo(m - d * 0.72, m);
  g.closePath();
  g.fill();
  const t = tex(c);
  t.generateMipmaps = true;
  t.minFilter = THREE.LinearMipmapLinearFilter;
  return t;
}
